// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".downsample-panel{display:flex;margin:0 -8px;padding-bottom:16px}.downsample-panel .duration-input{width:200px;margin-bottom:8px}.downsample-panel .downsample-panel--left{padding:0 8px}.downsample-panel .downsample-panel--right{padding:0 8px}", ""]);
// Exports
module.exports = exports;
